export default __webpack_public_path__ + "static/media/upload_names.37d84190.svg";